import { render, staticRenderFns } from "./CheckAdmitCard.vue?vue&type=template&id=5f049512&scoped=true&"
import script from "./CheckAdmitCard.vue?vue&type=script&lang=js&"
export * from "./CheckAdmitCard.vue?vue&type=script&lang=js&"
import style0 from "./CheckAdmitCard.vue?vue&type=style&index=0&id=5f049512&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f049512",
  null
  
)

export default component.exports